import ngwImg from "static/gardian_watchmen.png";
import hakaiImg from "static/hakai_logo.png";
import ntImg from "static/nature_trust.jpg";
import pcImg from "static/parks_canada.jpg";
import wscImg from "static/wsc.jpg";
import uwtImg from "static/uwt.png";
import sfcImg from "static/sfc.png";
import ncImg from "static/nc_logo.png";
import hirmdImg from "static/hirmd_logo.jpg";

// Every organization the portal knows about. To add one, drop its logo in
// src/static and append a single entry here.
//
// name  - must match the string the API returns in user.organizations, which is
//         what gates visibility on the organization picker.
// label - what the picker button displays.
// img   - logo shown on the picker button.
// soloSupported - Solo uploads are only offered for organizations flagged true
//         (see util/solo.js). Omit for organizations without Solo support.
const organizations = [
  {
    name: "HAKAI",
    label: "Hakai",
    img: hakaiImg,
    soloSupported: true
  },
  {
    name: "NATURE TRUST",
    label: "Nature Trust",
    img: ntImg
  },
  {
    name: "GWNANWAKOLAS",
    label: "Nanwakolas Guardian Watchmen",
    img: ngwImg
  },
  {
    name: "PARKS CANADA",
    label: "Parks Canada",
    img: pcImg
  },
  {
    name: "WSC",
    label: "Water Survey of Canada",
    img: wscImg
  },
  {
    name: "UWT",
    label: "University of Washington Tacoma",
    img: uwtImg
  },
  {
    name: "SFC",
    label: "Skeena Fisheries Commission",
    img: sfcImg
  },
  {
    name: "NC50",
    label: "Na̲nwak̲olas Council",
    img: ncImg
  },
  {
    name: "HIRMD",
    label: "HIRMD",
    img: hirmdImg
  }
];

export default organizations;
